(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name commons.service:CommonDataModel
     *
     * @description
     *
     */
    angular
        .module('commons')
        .service('CommonDataModel', CommonDataModel);

    function CommonDataModel(rx) {
        var self = this;

        /**
         * Exposed Common Data Models
         * @type {rx.ReplaySubject}
         */
        self.appWeekStartDay = new rx.ReplaySubject();

        /**
         *  update appWeekStartDay Setters
         */
        self.setAppWeekStartDay = function (startDate) {
            self.appWeekStartDay.onNext(startDate);
        };
    }
}());
